import { render, staticRenderFns } from "./supplychain.vue?vue&type=template&id=70ae42b2&scoped=true&"
import script from "./supplychain.vue?vue&type=script&lang=js&"
export * from "./supplychain.vue?vue&type=script&lang=js&"
import style0 from "./supplychain.vue?vue&type=style&index=0&id=70ae42b2&lang=less&scoped=true&"
import style1 from "./supplychain.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae42b2",
  null
  
)

export default component.exports